"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvancedSearchDropdownContainer = exports.onSearchButtonClick = void 0;
var React = require("react");
var fp = require("fp-ts");
var moment = require("moment");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var DatePicker_1 = require("components/DatePicker");
var FileTypeSelector_1 = require("./FileTypeSelector");
var FolderSelector_1 = require("./FolderSelector");
var Icon_1 = require("components/Icon");
var MetaSelector_1 = require("./MetaSelector");
var onSearchButtonClick = function (props) { return function (options) {
    props.onSearchFiles(__assign(__assign({}, props.searchOptions), { containsTermString: props.__contentSearchString, searchString: props.__searchString ? props.__searchString : '', moreSearch: true, searchFileType: props.__searchType, limitSearchToFolder: props.__targetFolders, from: props.__fromSearch, to: props.__toSearch, allVersions: props.__allVersions, meta: props.__selectedMetaColumn, metaValue: props.__metaValue }));
}; };
exports.onSearchButtonClick = onSearchButtonClick;
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('foldersToggled', 'toggleFolders', false), (0, recompose_1.withState)('searchTypeToggled', 'toggleSearchType', false), (0, recompose_1.withState)('metaSelectorToggled', 'toggleMetaSelector', false), (0, recompose_1.withState)('metaOptionToggled', 'toggleMetaOption', false), (0, recompose_1.withStateHandlers)(function (props) { return ({
    __searchString: props.searchOptions.searchString,
    __contentSearchString: props.searchOptions.containsTermString,
    __searchType: props.searchOptions.searchFileType,
    __targetFolders: props.searchOptions.limitSearchToFolder,
    __fromSearch: props.searchOptions.from,
    __toSearch: props.searchOptions.to,
    __allVersions: props.searchOptions.allVersions,
    __selectedMetaColumn: props.searchOptions.meta,
    __metaValue: props.searchOptions.metaValue
}); }, {
    __setSearchString: function (_a) {
        var __searchString = _a.__searchString;
        return function (value) { return ({
            __searchString: value
        }); };
    },
    __setContentSearchString: function (_a) {
        var __contentSearchString = _a.__contentSearchString;
        return function (value) { return ({
            __contentSearchString: value
        }); };
    },
    __setSearchType: function (_a) {
        var __searchType = _a.__searchType;
        return function (value) { return ({
            __searchType: value
        }); };
    },
    __setTargetFolders: function (_a) {
        var __targetFolders = _a.__targetFolders;
        return function (value) { return ({
            __targetFolders: value
        }); };
    },
    __setFromSearch: function (_a) {
        var __fromSearch = _a.__fromSearch;
        return function (value) { return ({
            __fromSearch: value
        }); };
    },
    __setToSearch: function (_a) {
        var __toSearch = _a.__toSearch;
        return function (value) { return ({
            __toSearch: value
        }); };
    },
    __setAllVersions: function (_a) {
        var __allVersions = _a.__allVersions;
        return function (value) { return ({
            __allVersions: value
        }); };
    },
    __setSelectedMetaColumn: function (_a) {
        var __selectedMetaColumn = _a.__selectedMetaColumn;
        return function (value) { return ({
            __selectedMetaColumn: value
        }); };
    },
    __setMetaValue: function (_a) {
        var __metaValue = _a.__metaValue;
        return function (value) { return ({
            __metaValue: value
        }); };
    }
}), recompose_1.pure);
exports.AdvancedSearchDropdownContainer = enhance(function (props) { return (React.createElement(sok_ui_1.ClickWall, null,
    React.createElement("div", { className: "advanced-search-container" },
        React.createElement("div", { className: "search-header" },
            React.createElement("span", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools')),
            React.createElement("span", { className: "close-button" },
                React.createElement(Icon_1.Icon, { onClick: props.toggleAdvancedSearchDropdown, className: "fa-times" }))),
        React.createElement(sok_ui_1.Form, { className: "advanced-search-form", onSubmit: (0, exports.onSearchButtonClick)(props) },
            React.createElement(sok_ui_1.Input, { type: 'text', value: props.__searchString, name: 'inputName', onChange: function (e) {
                    return props.__setSearchString(e.target.value);
                }, label: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/fileName'), placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/fileName/placeHolder/enterAtermThatMatchesPartOfTheFileName') }),
            React.createElement(sok_ui_1.Input, { type: 'text', value: props.__contentSearchString, name: 'contentSearchTerm', disabled: props.__searchType.isSome() && props.__searchType.value === 'FOLDER', onChange: function (e) {
                    props.__setContentSearchString(e.target.value);
                }, label: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/containsText'), placeholder: !(props.searchOptions.searchFileType.isSome() &&
                    props.searchOptions.searchFileType.value === 'FOLDER')
                    ? (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/containsText/placeHolder/enterAtermThatMatchesFileContent')
                    : (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/label/containsText/placeHolder/cantusewithfolder') }),
            React.createElement(FileTypeSelector_1.FileTypeSelector, { setSearchType: props.__setSearchType, searchOption: props.__searchType, isOpen: props.searchTypeToggled, toggle: props.toggleSearchType }),
            React.createElement(FolderSelector_1.FolderSelector, { folderList: props.topLevelFolders, onLimitToFolder: props.__setTargetFolders, limitSearchToFolder: props.__targetFolders, isOpen: props.foldersToggled, toggle: props.toggleFolders, optionsList: [] }),
            React.createElement(MetaSelector_1.MetaSelector, { metadata: props.metadata, selectedMeta: props.__selectedMetaColumn, setSelectedMeta: props.__setSelectedMetaColumn, metaValue: props.__metaValue, setMetaValue: props.__setMetaValue, isOpen: props.metaSelectorToggled, toggle: props.toggleMetaSelector, metaOptionIsOpen: props.metaOptionToggled, toggleMetaOption: props.toggleMetaOption }),
            React.createElement("div", { className: 'period-search sok-form-field text' },
                React.createElement("div", { className: 'input' },
                    React.createElement("label", null, (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/limitToTime')),
                    React.createElement(sok_ui_1.Row, null,
                        React.createElement(sok_ui_1.Column, { medium: 3, extraSmall: 6 },
                            React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/dateFrom'), selected: props.__fromSearch && moment(props.__fromSearch, 'L HH:mm'), onChange: function (m, e) {
                                    if (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }
                                    props.__setFromSearch(m);
                                }, selectsStart: true, maxDate: props.__toSearch || undefined, dateFormat: "L", className: 'date' })),
                        "-",
                        React.createElement(sok_ui_1.Column, { medium: 3, extraSmall: 6 },
                            React.createElement(DatePicker_1.DatePicker, { placeholder: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/dateTo'), selected: props.__toSearch && moment(props.__toSearch, 'L HH:mm'), onChange: function (m, e) {
                                    if (e) {
                                        e.stopPropagation();
                                        e.preventDefault();
                                    }
                                    if (m) {
                                        m.hour(23);
                                        m.minute(59);
                                        m.second(59);
                                    }
                                    props.__setToSearch(m);
                                }, selectsEnd: true, minDate: props.__fromSearch || undefined, dateFormat: "L" })),
                        React.createElement(sok_ui_1.Column, { medium: 3, extraSmall: 12 },
                            React.createElement(sok_ui_1.Input, { type: 'checkbox', label: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/includeRevisions') }))))),
            React.createElement("div", { className: 'bottom-bar' },
                React.createElement("div", { className: "buttons" },
                    React.createElement(sok_ui_1.Button, { onClick: function () {
                            props.__setContentSearchString(null);
                            props.__setSearchString(null);
                            props.__setSearchType(fp.option.none);
                            props.__setTargetFolders(fp.option.none);
                            props.__setAllVersions(false);
                            props.__setFromSearch(null);
                            props.__setToSearch(null);
                            props.__setSelectedMetaColumn(null);
                            props.__setMetaValue(null);
                        }, type: 'reset', text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/buttoms/reset') }),
                    React.createElement(sok_ui_1.Button, { className: "submit-button", color: 'base-green', type: 'submit', text: (0, translation_1.getLocalization)('userfront/project/files/targetYourSearch/AdvancedSearchDropdownContainer/moreSearchTools/buttoms/search') }))))))); });
